import { Link } from "react-router-dom";

const Menu = () => {
    return (
        <div>
            <Link to="/">Home</Link>
            <br />
            <Link to="/trash">Trash</Link>
            <br />
            <Link to="/laundry">Laundry</Link>
            <br />
            <Link to="/crypto">Crypto</Link>
            <br />
            <Link to="/content-manager">Content Manager</Link>
        </div>
    );
}
export default Menu;
